/** Emails allowed to request a login/signup magic link on production (doggos.com).
 * Workspace teammates invited to an account are also allowed once their Stream
 * user has accountId/listingId (see isProductionWorkspaceLoginUser).
 */
export const PRODUCTION_ALLOWED_LOGIN_EMAILS = Object.freeze([
  'jacqueline@doggos.com',
  'manager@zpethotels.com',
])

export function normalizeLoginEmail(email) {
  return String(email || '').trim().toLowerCase()
}

export function isProductionAllowedLoginEmail(email) {
  return PRODUCTION_ALLOWED_LOGIN_EMAILS.includes(normalizeLoginEmail(email))
}

/**
 * Invited workspace teammates get Stream `accountId` / `listingId` at invite
 * time. They must be able to request magic links on production without being
 * on the hard email allowlist.
 */
export function isProductionWorkspaceLoginUser(streamUser) {
  if (!streamUser || typeof streamUser !== 'object') return false
  return Boolean(
    String(streamUser.accountId || streamUser.listingId || '').trim(),
  )
}
